<template>
  <button
    type="button"
    class="gray-button mt-3 flex w-full items-center justify-center gap-2 rounded-2xl p-3.5 text-base font-semibold disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="disabled"
    @click="emit('onClick')"
  >
    <span
      v-if="$slots.icon"
      class="inline-flex h-6 w-6 shrink-0 items-center justify-center text-current"
      aria-hidden="true"
    >
      <slot name="icon" />
    </span>
    <slot />
  </button>
</template>

<script setup lang="ts">
  defineProps<{
    disabled?: boolean;
    dataQaId?: string;
  }>();

  const emit = defineEmits<{
    onClick: [];
  }>();
</script>
